import API from "@/api/lib/api";

export const getAllRole = async () => {
  try {
    const response = await API.get(`/acl/roles`);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const createRole = async (data) => {
  try {
    const response = await API.post(`acl/roles`, data);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const updateRole = async (id, data) => {
  try {
    const response = await API.put(`acl/roles/${id}`, data);
    return response.data
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const deleteRole = async (id) => {
  try {
    const response = await API.delete(`acl/roles/${id}`);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};
